import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import LoadingPanel from "../../common/LoadingPanel";
import { Grid, GridColumn } from "@progress/kendo-react-grid";

class AvizoNegenerovaneSpravy extends Component {
    lastSelectedIndex = 0;
    state = {
        loading: false
    };

    changeSelectedItemId = (e) => {
        var items = this.props.items;

        let last = this.lastSelectedIndex;
        const current = items.findIndex((dataItem) => dataItem === e.dataItem);

        if (!e.nativeEvent.shiftKey) {
            this.lastSelectedIndex = last = current;
        }

        if (!e.nativeEvent.ctrlKey) {
            items.forEach((item) => (item.selected = false));
        }
        const select = !e.dataItem.selected;
        for (let i = Math.min(last, current); i <= Math.max(last, current); i++) {
            items[i].selected = select;
        }
        this.props.changeSelectedItemIds(items.filter((dataItem) => dataItem.selected).map((a) => a.sklad));

        this.forceUpdate();
    };

    renderTable(items) {
        var localizationService = provideLocalizationService(this);

        return (
            <div id="NegenerovaneSpravy" onMouseDown={(e) => e.preventDefault() /* prevents browser text selection */}>
                <Grid data={items} selectedField="selected" onRowClick={this.changeSelectedItemId}>
                    <GridColumn field="sklad" title={localizationService.toLanguageString("TextNegenerovaneSpravy.Grid.IDSklad", "IDSklad")} />
                    <GridColumn field="skratka" title={localizationService.toLanguageString("TextNegenerovaneSpravy.Grid.Predajňa", "Predajňa")} />
                    <GridColumn field="nazov" title={localizationService.toLanguageString("TextNegenerovaneSpravy.Grid.Názov", "Názov")} />
                    <GridColumn field="typSkladu" title={localizationService.toLanguageString("TextNegenerovaneSpravy.Grid.Typ skladu", "Typ skladu")} />
                    <GridColumn field="adresa" title={localizationService.toLanguageString("TextNegenerovaneSpravy.Grid.Adresa", "Adresa")} width="400px" />
                </Grid>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderTable(this.props.items);

        return <div>{contents}</div>;
    }
}

export default AvizoNegenerovaneSpravy;

registerForLocalization(AvizoNegenerovaneSpravy);



// WEBPACK FOOTER //
// ./src/components/views/Tools/AvizoNegenerovaneSpravy.js